module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hi":"Hi","login":"Login","menu":"Menu","notifications":"Notifications","close":"Close","order":"Ordering","search":"Search","explore":"Explore","lang":"العربية"},"ar":{"hi":"اهلا","login":"تسجيل دخول","menu":"القائمة","notifications":"التنبيهات","close":"اغلاق","order":"طلب خدمة","search":"بحث","explore":"اكتشف","lang":"English"}}')
  delete Component.options._Ctor
}
